export default __webpack_public_path__ + "static/akitabox_powered.e2186561e0773272bd7b0fecc4f7e421.svg";